import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./NewyearSuccessModal.css";
import "../../../assets/css/modal.css";
import activityLogSubmission from "../../../helper/activitylog";
import analyticEvent from "../../../helper/gaEvent";
import xImg from "./x.png";
import styles from "./NewyearSuccessModal.module.css";
import { useNavigate } from "react-router-dom";

const NewyearSuccessModal = ({
  showNewyearSuccessModal,
  setShowNewyearSuccessModal
}) => {

  const navigate = useNavigate();
  function hideModalOperation() {
    setShowNewyearSuccessModal(false);
  }

  useEffect(() => {
    activityLogSubmission("newyear-purchase-modal");
    analyticEvent("newyear-purchase-modal", "newyear-purchase-modal-view");
  }, []);

  return (
    <>
      <Modal
        show={showNewyearSuccessModal}
        centered
        dialogClassName="modal-dialog"
        contentClassName="modalContentNewyearSuccessModal"
        onHide={hideModalOperation}
      >
        <Modal.Body
          style={{
            overflow: "hidden",
            display: "block",
            overflowX: "hidden",
            padding: "6px 20px 0px",
          }}
        >
          <img
            src={xImg}
            alt="logo"
            className={styles.xImg}
            onClick={()=>{hideModalOperation(); navigate('../')}}
          />
          <section className={styles.div}>
            <div className={styles.div2}>
              <img
                src="https://ms.quizard.live/bkash-quiz-banner/assets/gif/success.gif"
                alt="Present"
                className={styles.presentImage}
              />
              <div className={styles.div5}>
                <h2 className={styles.span3}>সফলভাবে ২ রাউন্ড কিনেছেন</h2>
              </div>
              <div className={styles.div6}>
                <button className={styles.div7} onClick={()=>{navigate('/quiz/?eventId=80')}}>
                  খেলতে ক্লিক করুন
                </button>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default NewyearSuccessModal;
